import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { isServiceOperation } from "../utils/isServiceOperation";

const Badge = styled.span`
	display: inline-block;
	margin-left: 8px;
	padding: 1px 8px;
	border-radius: 4px;
	font-size: 11px;
	line-height: 16px;
	font-weight: 500;
	white-space: nowrap;
	vertical-align: middle;
	color: #1b7a3d;
	background: #e6f6ec;
`;

type Props = {
	name: string | null | undefined;
};

/**
 * Зелёная плашка рядом с именем операции, если это опрос самой диагностики.
 */
const ServiceOperationMark: React.FC<Props> = ({ name }) => {
	const { t } = useTranslation();

	if (!isServiceOperation(name)) return null;

	return (
		<Badge
			title={String(
				t("settings.systemPerformance.serviceOperationHint"),
			)}
		>
			{t("settings.systemPerformance.serviceOperation")}
		</Badge>
	);
};

export default ServiceOperationMark;
